import React from "react";
import WidgetSelector from "./WidgetSelector";

export default function WidgetFiscalYearSelector({
  value,
  displayValue,
  fiscalYears,
  onChange,
  reloadDropdownData,
  viewOnly,
  size,
  showCloudIcon = true,
  displayMaxWidth,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={fiscalYears}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Fiscal Year"
        showCloudIcon={showCloudIcon}
        size={size}
        displayMaxWidth={displayMaxWidth}
      />
    </React.Fragment>
  );
}
